export default {
    setLastFeedback(state, feedback) {
        state.lastFeedback = feedback;
    },
};
